import * as RadixDropdownMenu from '@radix-ui/react-dropdown-menu';
import React, { ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './ConditionSearch.styles';

export interface ConditionSearchProps {
  label?: string;
  children: ReactNode;
  dataTestId: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const ConditionSearch = ({
  label,
  children,
  dataTestId,
  onChange,
}: ConditionSearchProps) => {
  const { t } = useTranslation('scenario');
  const [isOpen, setIsOpen] = useState(false);

  return (
    <S.DropdownMenuRoot data-testid={dataTestId} open={isOpen}>
      <S.Trigger $active={false} onClick={() => setIsOpen(true)}>
        <S.TriggerLabel>{label}</S.TriggerLabel>
        <S.TriggerArrow iconName="ChevronLightDown" size={12} />
      </S.Trigger>
      <RadixDropdownMenu.Portal>
        <S.DropdownMenuContent
          align="start"
          sideOffset={5}
          side="bottom"
          onInteractOutside={() => setIsOpen(false)}
        >
          <S.StyledFilter
            placeholder={t('scenario:search')}
            onChange={onChange}
          />
          <S.ScrollableList role="listbox" onClick={() => setIsOpen(false)}>
            {children}
          </S.ScrollableList>
        </S.DropdownMenuContent>
      </RadixDropdownMenu.Portal>
    </S.DropdownMenuRoot>
  );
};
